import { ArrowDown } from "lucide-react";
import { fileToUrl } from "@/content/ContentContext";

export default function Hero({ content }) {
  const c = content || {};
  const scrollTo = (id) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative min-h-[100svh] w-full overflow-hidden"
    >
      <img
        src={fileToUrl(c.image_url)}
        alt="Elements Of Meaford"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 hero-mask" />

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-10 pt-40 md:pt-48 pb-24 min-h-[100svh] flex flex-col justify-between">
        <div className="max-w-3xl">
          <p
            data-testid="hero-overline"
            className="text-[var(--bone-2)] text-xs md:text-sm uppercase tracking-[0.35em] font-semibold mb-8 reveal"
          >
            {c.overline}
          </p>
          <h1
            data-testid="hero-title"
            className="font-serif-display text-5xl md:text-7xl lg:text-[5.5rem] leading-[1.02] font-medium text-[var(--bone)] tracking-tight reveal"
          >
            {c.title_line1}
            <br />
            <span className="italic text-[var(--bone-2)]">{c.title_line2} </span>
            <span className="italic">{c.title_line3}</span>
          </h1>
          <p
            data-testid="hero-subtitle"
            className="mt-8 max-w-xl text-base md:text-lg text-[var(--bone-2)] leading-relaxed reveal"
          >
            {c.subtitle}
          </p>

          <div className="mt-10 flex flex-wrap items-center gap-4 reveal">
            <button
              data-testid="hero-register-btn"
              onClick={() => scrollTo("register")}
              className="btn-primary"
            >
              {c.cta_primary || "Register Interest"}
            </button>
            <button
              data-testid="hero-configurations-btn"
              onClick={() => scrollTo("configurations")}
              className="btn-secondary"
              style={{ color: "#F8F5F2", borderColor: "#F8F5F2" }}
            >
              {c.cta_secondary || "View Configurations"}
            </button>
          </div>
        </div>

        <div className="hidden md:flex items-end justify-between text-[var(--bone-2)] text-xs uppercase tracking-[0.3em] font-semibold">
          <div className="flex items-center gap-3">
            <span className="block w-10 h-px bg-[var(--bone-2)]" />
            <span>{c.address_line}</span>
          </div>
          <button
            onClick={() => scrollTo("vision")}
            className="flex items-center gap-3 hover:text-[var(--bone)] transition-colors"
            data-testid="hero-scroll-down"
          >
            Scroll
            <ArrowDown size={16} className="animate-bounce" />
          </button>
        </div>
      </div>
    </section>
  );
}
